import { isScheduledLive, isStreamingLive, isPendingLiveStream } from './live';
import { hasTrailer, isTrailerPreviewTypeEnabled } from './preview';
import { isFree } from './pricing';
const hasPlayableTrailer = (video) => isTrailerPreviewTypeEnabled(video) && hasTrailer(video);
const isPaidLive = (video) => isStreamingLive(video) && !isFree(video);
const isPlayableOrHasPreview = (video) => !isScheduledLive(video) && !isPaidLive(video) && !isPendingLiveStream(video);
export const isPlayable = (videoItem) => hasPlayableTrailer(videoItem) || isPlayableOrHasPreview(videoItem);
//# sourceMappingURL=play.js.map